import { merchantApi } from '@/config/axios'

// ========== 商家端售后退款 API ==========

export interface AfterSaleVO {
  id?: number
  no?: string // 售后单号
  status?: number // 退款状态
  way?: number // 售后方式 10=仅退款 20=退货退款 30=换货
  type?: number // 售后类型
  userId?: number
  applyReason?: string
  applyDescription?: string
  applyPicUrls?: string[] // 买家凭证图
  orderId?: number
  orderNo?: string
  spuName?: string
  picUrl?: string
  count?: number
  refundPrice?: number // 退款金额（分）；换货为 0
  /** 售后商品项使用的积分（退款成功后原路退回） */
  usePoint?: number
  /** 积分抵扣金额（分） */
  pointPrice?: number
  /** 赠送积分（退款成功后扣回） */
  givePoint?: number
  /** 换货物流公司编号 */
  exchangeLogisticsId?: number
  /** 换货物流单号 */
  exchangeLogisticsNo?: string
  exchangeDeliveryTime?: string | number
  exchangeReceiveTime?: string | number
  orderItem?: {
    payPrice?: number
    usePoint?: number
    pointPrice?: number
    givePoint?: number
  }
  applyTime?: string | number
  createTime?: string | number
  payRefundId?: number
  logs?: AfterSaleLogVO[]
}

export interface AfterSaleLogVO {
  id?: number
  content?: string
  createTime?: string | number
  userType?: number
}

// 售后分页
export const getAfterSalePage = (params: any) => {
  return merchantApi.get({ url: '/merchant-api/trade/after-sale/page', params })
}

// 售后详情
export const getAfterSale = (id: number) => {
  return merchantApi.get({ url: `/merchant-api/trade/after-sale/get-detail?id=${id}` })
}

// 售后日志
export const getAfterSaleLogList = (afterSaleId: number) => {
  return merchantApi.get({ url: `/merchant-api/trade/after-sale/get-log-list?afterSaleId=${afterSaleId}` })
}

// 同意售后（可下调 refundPrice，单位：分；不传则保持申请金额）
export const agreeAfterSale = (data: { id: number; refundPrice?: number }) => {
  return merchantApi.put({ url: '/merchant-api/trade/after-sale/agree', data })
}

// 拒绝售后
export const disagreeAfterSale = (data: { id: number; auditReason: string }) => {
  return merchantApi.put({ url: '/merchant-api/trade/after-sale/disagree', data })
}

// 确认收货
export const receiveAfterSale = (id: number) => {
  return merchantApi.put({ url: `/merchant-api/trade/after-sale/receive?id=${id}` })
}

// 拒绝收货（body: id + refuseMemo）
export const refuseAfterSale = (data: { id: number; refuseMemo: string }) => {
  return merchantApi.put({ url: '/merchant-api/trade/after-sale/refuse', data })
}

// 确认退款
export const refundAfterSale = (id: number) => {
  return merchantApi.put({ url: `/merchant-api/trade/after-sale/refund?id=${id}` })
}

// 发出换货
export const deliveryExchange = (data: {
  id: number
  logisticsId: number
  logisticsNo: string
}) => {
  return merchantApi.put({ url: '/merchant-api/trade/after-sale/exchange-delivery', data })
}
